<template>
  <div class="menu-form">
    <v-container>
      <v-row dense>
        <v-col cols="12" sm="10" lg="8" xl="6" class="py-0 mx-auto">
          <v-row dense>
            <v-col class="pa-0">
              <h1 class="text-h5 font-weight-bold font-italic grey--text"
                >Our Menu</h1
              >
            </v-col>
          </v-row>
          <v-row v-if="galleryImgs.length" dense>
            <v-col class="mx-auto py-0">
              <MenuGallery :imgs="galleryImgs" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <WithMenu v-slot="{ sections, loading }">
        <transition name="fade" mode="out-in">
          <v-row v-if="loading">
            <v-col cols="12" sm="10" lg="8" xl="6" class="mx-auto text-center">
              <v-progress-circular
                indeterminate
                size="15"
                width="2"
                color="amber lighten-2"
                class="mx-auto"
              />
              <h3 class="grey--text text--darken-2 text-h6"
                >Loading the menu...</h3
              >
            </v-col></v-row
          >
          <v-row v-else-if="!sections">
            <v-col cols="12" sm="10" lg="8" xl="6" class="mx-auto">
              <h2>No Items Found</h2>
              <h3
                >We apologize, but there is nothing available for purchase at
                this time.</h3
              >
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" sm="10" lg="8" xl="6" class="mx-auto">
              <MenuForm :sections="sections" class="pb-14" />
              <v-row justify="center">
                <v-btn
                  color="deep-orange white--text"
                  fixed
                  bottom
                  :right="!_includes(['xs', 'sm', 'md'], $mq)"
                  x-large
                  depressed
                  @click="startOrderBtnClick"
                  class="mb-10 start-order-btn"
                  >Start an Order</v-btn
                >
              </v-row>
              <DatePickerFab />
            </v-col>
          </v-row>
        </transition>
      </WithMenu>
    </v-container>
  </div>
</template>

<script>
import { GuestRoutes } from '@/constants/RouteNames'
import { mapGetters } from 'vuex'
import MenuForm from '@/components/MenuForm'
import MenuGallery from '@/components/MenuGallery'
import DatePickerFab from '@/components/DatePickerFab'
import WithMenu from '@/components/DataProviders/WithMenu'
import _includes from 'lodash/includes'

export default {
  name: 'MenuView',
  components: { MenuForm, MenuGallery, DatePickerFab, WithMenu },
  data: () => {
    return {
      items: [],
    }
  },
  computed: {
    ...mapGetters('shop', ['getShopDetail']),
    ...mapGetters('auth', ['canMerchant']),

    galleryImgs() {
      let imgs = this.getShopDetail('Menu Gallery')
      return imgs ? JSON.parse(imgs) : []
    }, // galleryImgs
  },
  methods: {
    startOrderBtnClick() {
      if (!this.canMerchant && this.$gtag) {
        this.$gtag.event('start_order_btn')
      }
      this.$router.push({ name: GuestRoutes.NEW_ORDER })
    }, // startOrderBtnClick
    _includes,
  },
}
</script>

<style lang="css">
.start-order-btn {
  z-index: 4;
}
</style>
